import React from 'react';
import styled from 'styled-components'
import { ContainerFull } from '../container/full'
import ItemsBookmark from './items'
import LastUpload from './lastUpload'
import { FadeIn } from '../../theme/fadeIn'
import Loading from '../loading'
import { TopBar } from '../topBar'
import ChatFooter from './chatFooter';

const Content = styled.div`
    margin-top: 52px;
    min-height: 75vh;
    display flex;
    flex-direction: column-reverse;

    // overflow: scroll;
`;

export class Home extends React.Component {
    constructor(props) {
      super(props);

      this.changleFilter = this.changleFilter.bind(this);
      this.actionRight = this.actionRight.bind(this);

      this.state = {
        bookmarkInfo: '',
        bookmarkItems: '',
        currentFilter: 0,
        loadingSpinner: true
      };

      
    }

    changleFilter(e, index) {
        this.setState({ currentFilter: index })
    }



    fetchData() {
        fetch(`/v1/bookmark`, { method: 'GET', headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': "Bearer " + localStorage.getItem('token') } })
        .then(res => res.json())
        .then(json => this.setState({ loadingSpinner: false, bookmarkItems: json.items, filtered: json.items, bookmarkInfo: json.infoBookmark }))
        .catch(function(error) {
            console.log('There has been a problem with your fetch operation: ', error.message);
        });;
    }

    scrollToBottom() {
        this.el.scrollIntoView({ behavior: 'smooth' });
    }
    
    componentDidMount() {
        this.fetchData();
        document.title = "Unassiged | app.ns2k"
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    actionRight() {
        this.setState({ actionRight: !this.state.actionRight })
    }

    render() {
    return (
        <>
            <FadeIn>
                <ContainerFull>
                    <TopBar actionFrom="unassigned" dot={true} actionShowType={ this.actionShowType } title="Unassigned" actionLeft="tune" selectType="false" />
                        { this.state.loadingSpinner && <Loading /> }

                        <Content>
                        {
                            (this.state.bookmarkItems || []).slice(0,1).map((post, index) => (
                                <LastUpload
                                    key={index}
                                    icon={post.icon}
                                    title={post.title}
                                    desc={post.description} 
                                    link={post.link}
                                    id={post.id} 
                                />
                            ))
                        } 
                        {
                            (this.state.bookmarkItems || []).sort().map((post, index) => (
                                <ItemsBookmark
                                    key={index}
                                    icon={post.icon}
                                    title={post.title}
                                    desc={post.description} 
                                    created={post.created}
                                    link={post.link}
                                    id={post.id} 
                                />
                            ))
                        } 

                        </Content>

                        <ChatFooter />
                        <div ref={el => { this.el = el; }} />

                </ContainerFull>
            </FadeIn>
      </>
     );
    }
}

export default Home